import React from 'react';
import { ShuttlesAdmin } from '../../../components';

class shuttlesAdmin extends React.Component {
    render() {
        return (
            <ShuttlesAdmin />
        );
    }
}

export default shuttlesAdmin